import { SecondaryText } from '../../../pages/AspspSelectPage/index.styled';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../common/styles/breakpoints';
import { ReactComponent as ChevronLeft } from 'src/assets/icons/chevron-left-grey.svg';
import { useRedirectUrlQuery } from '../../../pages/VerificationPage/verificationQueries';
import { useVerificationId } from '../../../common/hooks/useVerificationId';
import { useFailedAttemptQuery } from '../../../common/hooks/useFailedAttemptQuery';

const StyledLink = styled.a`
  max-width: 215px;
  font-size: 0.875rem;
  height: auto;
  font-weight: bold;
  text-decoration: none;
  color: ${({ theme }) => theme.text.secondary};
  display: flex;
  align-items: center;

  svg {
    margin-right: 0.5rem;
  }

  ${media.w.min.px1200(css`
    font-size: 0.875rem;
  `)}
`;

const BackToPartnerPageButton = () => {
  const id = useVerificationId();
  const { data } = useRedirectUrlQuery(id);
  const isFailedLogin = useFailedAttemptQuery();

  if (!data) {
    return null;
  }

  return isFailedLogin === 'true' ? (
    <SecondaryText>
      <StyledLink href={`${data.redirectUrl}`}>
        <ChevronLeft /> <FormattedMessage id="error.toast.button" />
      </StyledLink>
    </SecondaryText>
  ) : (
    <></>
  );
};

export default BackToPartnerPageButton;
